/* eslint-disable react/display-name */
import React, { useState } from 'react'
import { Select, Modal } from 'antd'
import R from 'ramda'
import styled from 'styled-components'

const Label = styled.td`
  text-align: end;
  align-self: center;
`

const failAmpCodeOption = R.compose(
  R.map(([key, text]) => ({ key: key, text, value: key })),
  R.sortBy(([, text]) => text.toLowerCase()),
  R.toPairs
)

export default ({
  ampCodeMap,
  failCodeMap,
  openFailCodePrompt,
  setFailAmpCode,
  visible,
  ...props
}) => {
  const [failCode, setFailCode] = useState(props.failCode)
  const [ampCode, setAmpCode] = useState(props.ampCode)

  return (
    <Modal
      visible={visible}
      title="Fail / Amplification Code"
      onOk={() => setFailAmpCode(false, failCode, ampCode)}
      onCancel={() => openFailCodePrompt(false)}
      value={failCode}
      bodyStyle={{
        display: 'grid',
        gridTemplateColumns: '150px 1fr',
        gridRowGap: '5px',
        gridColumnGap: '10px',
        padding: '10px',
        overflowX: 'auto',
      }}
      width="40%"
      style={{ top: '30%' }}
    >
      <Label>Fail Code</Label>
      <Select
        showSearch
        placeholder="Fail Code"
        onChange={value => setFailCode(value)}
        value={failCode}
        allowClear
      >
        {failAmpCodeOption(failCodeMap).map(({ key, value, text }) => (
          <Select.Option value={value} key={key}>
            {text}
          </Select.Option>
        ))}
      </Select>

      <Label>Amplification Code</Label>
      <Select
        placeholder="Amplification Code"
        onChange={value => setAmpCode(value)}
        value={ampCode}
        allowClear
        showSearch
      >
        {failAmpCodeOption(ampCodeMap).map(({ key, value, text }) => (
          <Select.Option value={value} key={key}>
            {text}
          </Select.Option>
        ))}
      </Select>
    </Modal>
  )
}
